import React from 'react'

import Layout from '../components/layout'

const TermsPage = () => (
  <Layout>
    <article className="pa4 black-80">
       <h2>Conditions of Entry</h2>
       <p>
        <ul>
          <li>Open to any Artist who resides in Southland and Otago regions and all RCAC Friends of The Arts.</li>
          <li>Entry is limited to three pieces per artist UNLESS otherwise specified. However, if the size of the artwork from the majority of entry's is at our maximum size, due to limited space we may have to choose only the best works from each artist to be selected and exhibited.</li>
          <li>All works must be original and completed within the last two years.</li>
          <li>All works are to be original unaided work of the entrant.</li>
          <li>All artworks are subject to our selection process. Painting, drawing, sculpture, graphic art, photography, wearable art, jewellery and ceramics are all eligible.</li>
          <li>All artworks must be totally dry and professionally presented ready for hanging, with D -rings screwed onto frame 75mm from the top and strung.</li>
          <li>As works are unpacked, a condition report will be undertaken, and any concerns noted.</li>
          <li>If hung, the longest side of the artwork must not exceed 1200mm, height 1000mm (including frame). 3D works; 1500mm on the longest side. Works outside of these dimensions will not be accepted for this exhibition.</li>
          <li>Artist's name as for catalogue, title of work, medium and price must be printed clearly on the back of work as well as on a swing label (this is for storage).</li>
          <li>The organisers reserve the right to photograph or reproduce selected artworks, for publicity relating to the exhibition.</li>
          <li>All artworks must be for sale. A 30% commission will be deducted on all sales (or 25% for Friends of The Arts).</li>
          <li>Collection of any unsold artwork is the responsibility of the artist. All unsold artwork must be collected at the conclusion of the exhibition unless by prior arrangement. For out of town artists a return courier ticket must be included with your submission (or advise us of alternative arrangements).</li>
          <li>Insurance during transit and at the exhibition is the responsibility of the artist. Every effort will be made to ensure that all work is handled with the greatest of care.</li>
        </ul>
       </p>
       <p className="measure">
         Enquries Ph: <a href="tel:0284095941" className="fw7">(028 409 5941)</a> | Email: <a href="mailto:info@rivertonarts.org.nz" className="fw7">info@rivertonarts.org.nz</a>
       </p>
    </article>
  </Layout>
)

export default TermsPage
